<template>
  <ol
    v-if="userAgent.plugin"
    :class="$style.ol"
  >
    <li :class="$style.li">
      <div :class="$style.caption">
        {{ $trlMessage('gs.magic-button.plugin.step.1') }}
      </div>
      <div :class="$style.description">
        <link-button
          :class="$style.link"
          :to="userAgent.plugin"
          data-qa="install-magic-button"
          size="l"
          color="black"
          target="_blank"
        >
          {{ $trlMessage('magic-button.plugin.setup') }}
        </link-button>
      </div>
    </li>
    <li
      v-if="!userAgent.is_mobile"
      :class="$style.li"
    >
      <div :class="$style.caption">
        {{ $trlMessage('gs.magic-button.plugin.step.2') }}
      </div>
      <div :class="$style.description">
        <div :class="$style.group">
          <div :class="$style.key">
            <template v-if="userAgent.device === 'mac'">
              alt
            </template>
            <template v-else>
              Alt
            </template>
          </div>
          <div :class="$style.keySign">
            +
          </div>
          <div :class="$style.key">
            S
          </div>
        </div>
      </div>

      <div :class="$style.info">
        {{ $trlMessage('gs.magic-button.plugin.step.2.or') }}
      </div>
    </li>
  </ol>
  <div v-else>
    <slot name="unsupported">
      {{ $trlMessage('gs.magic-button.plugin.not_supported') }}
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LinkButton from '@/shared/legacy/ui/button/link-button.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';
import { useGlobal } from '@/shared/legacy/lib/use-global';

const { $trlMessage } = useGlobal();
const userAgent = computed(() => appConfig.get('userAgent'));
</script>

<style module>
.ol {
  padding: 0;
  margin: 0 0 0 18px;
}
.li {
  margin-bottom: 30px;
}
.li::marker {
  font-weight: 500;
}
.li:first-child:last-child {
  list-style: none;
}
.caption {
  font-weight: 500;
}
.description {
  margin-top: 10px;
}
.link {
  width: 250px;
  justify-content: center;
}
.group {
  align-items: flex-end;
  display: inline-flex;
  gap: 5px;
}
.key {
  border: 1px solid #cccccc;
  border-radius: 8px;
  font-size: 30px;
  line-height: 22px;
  color: #333333;
  padding: 25px 35px 10px 20px;
  min-width: 90px;
}
.keySign {
  font-size: 1px;
  background-image: url(~@static/i/blocks/key/sign.svg);
  width: 15px;
  height: 16px;
  margin-bottom: 12px;
  margin-left: 7px;
  margin-right: 7px;
}
.info {
  margin-top: 15px;
}
</style>

<i18n lang="json">{}</i18n>
